// src/lib/supabase.js
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ Faltan variables de entorno de Supabase. Crea un archivo .env con REACT_APP_SUPABASE_URL y REACT_APP_SUPABASE_ANON_KEY')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  }
})

// Helpers de permisos por rol
export const ROLES = {
  ADMIN: 'admin',
  CAPATAZ: 'capataz',
  VETERINARIO: 'veterinario',
  COMERCIAL: 'comercial',
  FINANZAS: 'finanzas',
  TECNICO: 'tecnico_telecom',
  CONSTRUCCION: 'construccion',
  INVERSIONISTA: 'inversionista',
}

export const PERMISOS = {
  agro: [ROLES.ADMIN, ROLES.CAPATAZ, ROLES.VETERINARIO],
  cultivos: [ROLES.ADMIN, ROLES.CAPATAZ],
  finanzas: [ROLES.ADMIN, ROLES.FINANZAS],
  clientes: [ROLES.ADMIN, ROLES.COMERCIAL],
  usuarios: [ROLES.ADMIN],
  reportes: [ROLES.ADMIN, ROLES.FINANZAS, ROLES.INVERSIONISTA],
  vacunas: [ROLES.ADMIN, ROLES.VETERINARIO],
}

export function tienePermiso(rol, modulo) {
  if (!rol || !modulo) return false
  return PERMISOS[modulo]?.includes(rol) ?? false
}

export const ROLES_LABELS = {
  admin: 'Socio / Admin',
  capataz: 'Capataz',
  veterinario: 'Veterinario',
  comercial: 'Comercial',
  finanzas: 'Finanzas',
  tecnico_telecom: 'Técnico Telecom',
  construccion: 'Construcción',
  inversionista: 'Inversionista',
}

export const ROLES_COLORS = {
  admin: '#6366f1',
  capataz: '#16a34a',
  veterinario: '#0891b2',
  comercial: '#d97706',
  finanzas: '#7c3aed',
  tecnico_telecom: '#0f172a',
  construccion: '#b45309',
  inversionista: '#64748b',
}
